import { dehydrateApolloClient, initApolloClient } from "../apolloClient";
import {
  GET_LISTING,
  GET_LISTING_EXTENDED_DETAILS,
  GET_LISTING_FULL_DETAILS,
} from "@/graphql/queries/listing";
import GET_RELATED_LISTINGS from "../../graphql/queries/related-listings";
import { GET_ALL_DISTRICTS } from "@/graphql/queries/regions";
import { CLOSED_STATUS_MAP } from "@/components/Listing/ListingScreen/alert";
import {
  FINANCING_TEXTS,
  GET_DAILY_RENT_GUARANTEE_CONFIG,
} from "@/graphql/queries/info";
import {
  GET_LAST_STAT,
  GET_RESIDENTIAL_STATS_CONFIG,
} from "@/graphql/queries/statisitcal";

import { getSize, hasResidentialStats } from "@/lib/helpers";
import { getUnitUrl } from "@/containers/project-screen/ProjectCard";

export const Listing = {
  Resolve: async (ctx, $res) => {
    /**
     *  Listing page resolver
     *  this should resolve if path segments == 4||5
     * */

    const [, , , districtOrListing, listingOrPage, tooLong] =
      ctx?.query?.params || [];

    if (!ctx.path.direction) {
      ctx.listingUri = districtOrListing;
    } else {
      ctx.listingUri = listingOrPage;
    }
    if (tooLong) return {};

    const client = initApolloClient();

    const promises = [];
    try {
      const {
        data: {
          Web: { listing },
        },
      } = await client.query({
        query: GET_LISTING,
        variables: {
          uri: ctx.listingUri,
        },
      });
      /* if it's a daily rent listing redirect to /daily-rent */
      if (
        listing?.daily_rentable &&
        ctx?.path.basePath !== "/daily-rent" &&
        ctx?.path.basePath !== "/الحجز-اليومي"
      )
        return ctx.redirect(encodeURI(`/daily-rent${listing.path}`));

      // if listing is a project unit redirect to project init
      if (listing?.project_id) {
        const unitPath = getUnitUrl({
          unitId: listing?.id,
          unitCode: listing?.unit_code,
          ...listing?.project,
        });
        return ctx.redirect(encodeURI(unitPath));
      }

      /* if it's not a daily rent listing remove /daily-rent */
      if (
        !listing?.daily_rentable &&
        ctx?.path.basePath === "/daily-rent" &&
        ctx?.path.basePath === "/الحجز-اليومي"
      )
        return ctx.redirect(encodeURI(listing.path));

      promises.push(
        client.query({
          query: GET_LISTING_EXTENDED_DETAILS,
          variables: {
            id: listing.id,
          },
        }),
        client.query({
          query: GET_RESIDENTIAL_STATS_CONFIG,
        }),
      );

      if (CLOSED_STATUS_MAP[listing.status]) {
        promises.push(
          await client.query({
            query: GET_ALL_DISTRICTS,
            variables: {
              category: ctx.path.category.id,
              city_id: ctx.path.city.id,
              direction_id: ctx.path.direction?.id,
            },
          }),
        );
      }
      promises.push(
        await client.query({
          query: FINANCING_TEXTS,
        }),
        await client.query({
          query: GET_RELATED_LISTINGS,
          variables: {
            id: listing.id,
            size: 5,
          },
        }),
      );

      if (listing && listing.user_id === ctx.authState?.user?.user_id)
        promises.push(
          await client.query({
            context: { token: ctx.authState?.token },
            query: GET_LISTING_FULL_DETAILS,
            variables: {
              id: listing.id,
            },
          }),
        );

      if (listing?.daily_rentable) {
        promises.push(
          await client.query({
            query: GET_DAILY_RENT_GUARANTEE_CONFIG,
          }),
        );
      }

      const [getListingExtendedDetailsRes, residentialStatsConfigRes] =
        await Promise.all(promises);

      const {
        data: {
          Listing: { getListingExtendedDetails },
        },
      } = getListingExtendedDetailsRes;
      ctx.path.listing = {
        ...listing,
        views: `${listing.views}`,
        __router__: {
          disabled: true,
        },
        extended_details: getListingExtendedDetails,
      };

      ctx.path.residentialStatsConfig =
        residentialStatsConfigRes?.data?.Info?.configurations?.residential_stats;

      const doesCategoryHaveStats = hasResidentialStats(
        ctx.path.category,
        ctx.path.residentialStatsConfig,
      );

      if (
        doesCategoryHaveStats &&
        getSize(listing, ctx.path.category.id) != null
      ) {
        await client.query({
          query: GET_LAST_STAT,
          variables: {
            category: ctx.path.category.id,
            district_id: ctx.path.district?.id,
            size: getSize(listing, ctx.path.category.id),
          },
        });
      }

      return $res(dehydrateApolloClient(client, {}));
    } catch (e) {
      const id = getIdFromUrl(ctx.listingUri);

      if (!ctx?.query?.err && id) {
        return ctx.redirect(encodeURI(`/ad/${id}?err=true`));
      }
      throw e;
    }
  },
};
export function getIdFromUrl(url) {
  try {
    let ids = (url || "").match(/-[0-9]+/gi);
    return parseInt(ids[ids?.length - 1]?.replace("-", ""), 10);
  } catch {
    return null;
  }
}
export default Listing;
